import React, { useEffect, useState, useRef } from "react";
import {
  formatCurrency,
  getAlert,
  parseCurrency,
} from "../../../utils/SamuiUtils";
import Page2screenModal from "../../components/Modal/page2screenModal";

import socket from "../../../socket";
const BACKEND_URL =
  process.env.REACT_APP_API_URL || "https://pbposuat-backend.appsystemyou.com";
const SOCKET_PATH = process.env.REACT_APP_SOCKET_PATH || "/socket.io";

const PAYMENT_METHODS = {
  cash: "เงินสด",
  transfer: "โอนเงิน",
  // cheque: "เช็ค",
  credit: "เครดิต",
  unpaid: "ค้างชำระ",
  tiktok: "TikTok",
};

const PaymentModal = ({
  show,
  grandTotal,
  paymentType,
  setPaymentType,
  paymentAmount,
  setPaymentAmount,
  handlePayTypeClose,
  handleUpdatePayment,
  handleUploadSlip,
  base64Image,
  setBase64Image,
  chequeNo,
  setChequeNo,
  chequeName,
  setChequeName,
  chequeBranch,
  setChequeBranch,
  setIsPrint,
  amountReceived,
  setAmountReceived,
  rawAmountReceived,
  setRawAmountReceived,
  changeAmount,
  setChangeAmount,
  formDetailList,
}) => {
  const [showConfirmModal, setShowConfirmModal] = React.useState(false);

  const [showTwoScreenModal, setShowTwoScreenModal] = React.useState(false);
  const [displayStatus, setDisplayStatus] = React.useState("connecting");
  const [currentSessionData, setCurrentSessionData] = React.useState(null);

  const currentUserName = localStorage.getItem("name") || "SYSTEM";
  const hisPaymentIdRef = useRef(null);

  const totalPaid = Object.values(paymentAmount).reduce(
    (acc, val) => acc + parseCurrency(val || 0),
    0
  );

  const onClose = () => {
    closeQR();
    handlePayTypeClose();
  };

  const togglePaymentMethod = (method) => {
    const isGroupAMethod = GROUP_A.includes(method);
    const isGroupBMethod = GROUP_B.includes(method);

    const newSelected = {
      cash: false,
      transfer: false,
      // cheque: false,
      credit: false,
      unpaid: false,
    };

    // toggle ปุ่มที่เลือก
    newSelected[method] = !paymentType[method];

    // ล้างกลุ่มตรงข้าม
    if (isGroupAMethod) GROUP_B.forEach((m) => (newSelected[m] = false));
    if (isGroupBMethod) GROUP_A.forEach((m) => (newSelected[m] = false));

    // ล้างข้อมูลเช็คถ้าถอดออก
    if (method === "cheque" && !newSelected[method]) {
      setChequeNo("");
      setChequeName("");
      setChequeBranch("");
    }

    setPaymentType(newSelected);

    // ตั้งยอดเงินเฉพาะช่องที่เลือกเท่านั้น
    const updatedAmount = {};
    Object.keys(PAYMENT_METHODS).forEach((m) => {
      updatedAmount[m] = newSelected[m] ? formatCurrency(grandTotal) : "0.00";
    });
    setPaymentAmount(updatedAmount);

    // ตั้งยอดรับให้ตรงกับช่องทางที่ถูกเลือก (เช่น เงินสด, โอน)
    const selectedMethod = Object.keys(newSelected).find((m) => newSelected[m]);
    const selectedAmount = updatedAmount[selectedMethod] || "0.00";

    setAmountReceived(selectedAmount);
    setRawAmountReceived(selectedAmount);
    setChangeAmount(formatCurrency(0));
  };

  useEffect(() => {
    if (show) {
      // เคลียร์สถานะ
      const initialType = {
        cash: false,
        transfer: true, // << ตั้ง default ที่นี่แทน
        // cheque: false,
        credit: false,
        unpaid: false,
      };
      const initialAmount = {
        cash: "0.00",
        transfer: formatCurrency(grandTotal),
        cheque: "0.00",
        credit: "0.00",
        unpaid: "0.00",
      };

      setPaymentType(initialType);
      setPaymentAmount(initialAmount);
      setChequeNo("");
      setChequeName("");
      setChequeBranch("");
      setBase64Image("");

      setAmountReceived(formatCurrency(grandTotal));
      setRawAmountReceived(formatCurrency(grandTotal));
      setChangeAmount(formatCurrency(0));
    }
  }, [show]);

  const socketRef = useRef(null);
  const currentSessionIdRef = useRef(null);
  const wantPrintRef = useRef(false);
  const PROMPTPAY_QR_URL =
    process.env.REACT_APP_QR_URL ||
    // "https://23samuiice2024.s3.ap-southeast-1.amazonaws.com/SO_H/Screenshot+2025-10-08+183059.png";
    "https://files.appsystemyou.com/systemyou/SO_H/Screenshot%202025-10-24%20215716.png";

  useEffect(() => {
    // เมื่อ server ประกาศว่าจ่ายสำเร็จถึงจะบันทึก/พิมพ์จริง
    const onPaid = (p) => {
      const sid = String(p?.sessionId ?? "");
      if (!sid || String(currentSessionIdRef.current) !== sid) return;
      // ป้องกันยิงซ้ำ
      currentSessionIdRef.current = null;

      // ทำงานบันทึกจริง ณ ตอนนี้
      setShowTwoScreenModal(false);
      setDisplayStatus("connecting");
      Promise.resolve()
        .then(() => handleUpdatePayment(true))
        .catch((e) => {
          console.error("handleUpdatePayment failed:", e);
          getAlert("FAILED", "บันทึก/พิมพ์ล้มเหลว");
        });
    };

    const onDisplayVisible = (p = {}) => {
      const sid = String(p?.sessionId ?? "");
      if (!sid || String(currentSessionIdRef.current) !== sid) return;
      setDisplayStatus("visible");
    };

    // สมัคร event บน socket ส่วนกลาง
    socket.on("payment:success", onPaid);
    socket.on("display:qr:visible", onDisplayVisible);

    return () => {
      // cleanup ถูกต้อง
      socket.off("payment:success", onPaid);
      socket.off("display:qr:visible", onDisplayVisible);
    };
  }, [handleUpdatePayment]);

  // ใช้ socket ส่วนกลางแทน socketRef.current
  const startQrSession = async (amt) => {
    const res = await fetch(`${BACKEND_URL}/api/payment/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
      amount: amt,
      sourceType:"POS" ,
      qrCreateByType: "SYSTEM",
      qrCreateByUser: currentUserName,
    }),
    });
    if (!res.ok) throw new Error("CREATE_SESSION_FAILED");
    const data = await res.json();

    currentSessionIdRef.current = String(data.sessionId);
    hisPaymentIdRef.current = data.hisPaymentId || null;

    // เปลี่ยนจาก QR ของธนาคารเป็นรูปภาพที่กำหนดเอง
    const dynamicQR = "/kbank_qr2.jpg";
    const chargeId = data.chargeId;

    const sessionPayload = {
      sessionId: currentSessionIdRef.current,
      orderId: currentSessionIdRef.current,
      chargeId,
      amount: amt,
      items: (formDetailList || []).map((it, i) => ({
        name:
          it.Product_Name ||
          it.product_name ||
          it.Item_Name ||
          it.name ||
          `สินค้า ${i + 1}`,
        qty: Number(it.Qty ?? it.qty ?? 1),
        amount: Number(
          it.Net_Total ?? it.amount ?? it.total ?? it.Price ?? it.price ?? 0
        ),
      })),
      promptpayQR: dynamicQR,
      qrData: dynamicQR,
      hisPaymentId: hisPaymentIdRef.current,
    };

    setCurrentSessionData(sessionPayload);

    socket.emit("join-room", currentSessionIdRef.current);
    socket.emit("qr:show", sessionPayload);

    setDisplayStatus("connecting");
    setShowTwoScreenModal(true);
    return currentSessionIdRef.current;
  };

  // ปรับ closeQR ให้ใช้ socket โดยตรง
  const closeQR = () => {
    const sid = currentSessionIdRef.current;
    if (sid) {
      socket.emit("qr:close", { sessionId: sid });
      socket.emit("leave-room", sid);
    }

    currentSessionIdRef.current = null;
    setCurrentSessionData(null);
    setShowTwoScreenModal(false);
    setDisplayStatus("connecting");
  };

  // ปรับ paidOK ให้ใช้ socket ตรง ๆ
  const paidOK = () => {
    const sid = currentSessionIdRef.current;

    if (sid) socket.emit("payment:success", { sessionId: sid });
  };

  const handleChange = (method, value) => {
    setPaymentAmount((prev) => ({
      ...prev,
      [method]: value,
    }));
  };

  const handleFocus = (field, value) => {
    const rawValue = parseCurrency(value);
    setPaymentAmount((prev) => ({ ...prev, [field]: rawValue }));
  };

  const handleBlur = (field, value) => {
    const formattedValue = formatCurrency(parseCurrency(value));
    setPaymentAmount((prev) => ({ ...prev, [field]: formattedValue }));
  };
  const isAllGiftItems =
    formDetailList?.length > 0 &&
    formDetailList.every((item) => item.isGift === true);

  // ปุ่ม “บันทึก” = แค่เปิด QR และ “รอ”
  const handleConfirmPayment = async () => {
    const hasSelectedPaymentMethod = Object.values(paymentType).some(Boolean);
    if (!hasSelectedPaymentMethod && !isAllGiftItems) {
      getAlert("FAILED", "กรุณาเลือกช่องทางการชำระเงิน");
      return;
    }
    if (parseCurrency(amountReceived) === 0 && !isAllGiftItems) {
      getAlert("FAILED", "กรุณาระบุยอดชำระเงิน");
      return;
    }

    const isTransfer = !!paymentType.transfer && !isAllGiftItems;
    if (!isTransfer) {
      // เงินสด/เครดิต/อื่นๆ ทำงานปกติทันที
      await handleUpdatePayment(false);
      return;
    }

    try {
      wantPrintRef.current = false;
      const amt = parseCurrency(amountReceived || grandTotal);
      await startQrSession(amt); // ⬅️ โชว์ QR
      // จากนี้ “รอจนคุณเรียก markPaid()” (ปุ่มยืนยันเงินเข้า หรือ webhook)
    } catch (e) {
      console.error(e);
      getAlert("FAILED", "สร้างคำขอชำระล้มเหลว");
    }
  };

  // ปุ่ม “บันทึกและพิมพ์” = เหมือนกันแต่ตั้ง flag print
  const handleConfirmAndPrint = async () => {
    const hasSelectedPaymentMethod = Object.values(paymentType).some(Boolean);
    if (!hasSelectedPaymentMethod && !isAllGiftItems) {
      getAlert("FAILED", "กรุณาเลือกช่องทางการชำระเงิน");
      return;
    }
    if (parseCurrency(amountReceived) === 0 && !isAllGiftItems) {
      getAlert("FAILED", "กรุณาระบุยอดชำระเงิน");
      return;
    }

    const isTransfer = !!paymentType.transfer && !isAllGiftItems;
    if (!isTransfer) {
      await handleUpdatePayment(true);
      return;
    }

    try {
      wantPrintRef.current = true;
      const amt = parseCurrency(amountReceived || grandTotal);
      await startQrSession(amt); // ⬅️ โชว์ QR แล้วรอ markPaid()
    } catch (e) {
      console.error(e);
      getAlert("FAILED", "สร้างคำขอชำระล้มเหลว");
    }
  };

  const GROUP_A = ["cash", "transfer", "tiktok"]; // กลุ่มที่เลือกแล้วต้องปิดอีกกลุ่ม
  const GROUP_B = ["credit", "unpaid", "cheque"];

  const isGroupASelected = GROUP_A.some((method) => paymentType[method]);
  const isGroupBSelected = GROUP_B.some((method) => paymentType[method]);

  if (!show) return null;

  // const handleAmountReceivedChange = (value) => {
  //   const received = parseCurrency(value);
  //   setAmountReceived(formatCurrency(received));

  //   const change = received - parseCurrency(grandTotal);
  //   setChangeAmount(formatCurrency(change > 0 ? change : 0));
  // };

  const handleAmountReceivedChange = (value) => {
    const cleaned = value.replace(/[^\d.]/g, ""); // กรองเฉพาะตัวเลขและจุด
    // ตรวจสอบไม่ให้มีจุดมากกว่า 1 จุด
    const parts = cleaned.split(".");
    if (parts.length > 2) return; // ถ้ามีมากกว่า 1 จุด ให้ return ทันที
    setRawAmountReceived(cleaned);
  };

  const handleAmountReceivedBlur = () => {
    const parsed = parseCurrency(rawAmountReceived);
    const formatted = formatCurrency(parsed);
    setAmountReceived(formatted); // ค่อย format ตอน blur
    setRawAmountReceived(formatted);
    const change = parsed - parseCurrency(grandTotal);
    setChangeAmount(formatCurrency(change > 0 ? change : 0));
    
    //  FIX: อัปเดต paymentAmount ด้วย เพื่อให้ค่าที่บันทึกถูกต้อง
    const selectedMethod = Object.keys(paymentType).find((m) => paymentType[m]);
    if (selectedMethod && GROUP_A.includes(selectedMethod)) {
      setPaymentAmount((prev) => ({
        ...prev,
        [selectedMethod]: formatted,
      }));
    }
  };
  const rowStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    marginTop: "10px",
    fontSize: "18px",
    fontWeight: "bold",
  };

  const labelStyle = {
    width: "100px",
    textAlign: "right",
  };

  const valueStyle = {
    width: "140px",
    textAlign: "right",
    fontSize: "18px",
    fontWeight: "bold",
  };

  const unitStyle = {
    width: "40px",
    textAlign: "left",
  };

  return (
    <div
      className="modal"
      style={{
        display: "block",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1050,
      }}
    >
      <div className="modal-dialog modal-md" role="document">
        <div
          className="modal-content shadow-lg"
          style={{ borderRadius: "15px", overflow: "hidden" }}
        >
          <div
            className="modal-header"
            style={{
              backgroundColor: "#EF6C00",
              borderBottom: "none",
              padding: "20px",
            }}
          >
            <h5 className="modal-title fw-bold text-white">ชำระเงิน</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              // onClick={handlePayTypeClose}
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body" style={{ padding: "30px 20px" }}>
            <div
              class="p-3 text-center rounded"
              style={{ backgroundColor: "#FFEFCC" }}
            >
              <div style={rowStyle}>
                <div style={labelStyle}>ยอดชำระ:</div>
                <div style={valueStyle}>{formatCurrency(grandTotal)}</div>
                <div style={unitStyle}>บาท</div>
              </div>
              <div style={rowStyle}>
                <div style={labelStyle}>ยอดรับ:</div>
                {paymentType.transfer  ? (
                  <div style={valueStyle}>{formatCurrency(grandTotal)}</div>
                ) : (
                  <input
                    type="text"
                    className="form-control"
                    style={{
                      ...valueStyle,
                      paddingRight: "12px",
                      borderRadius: "6px",
                      fontFamily: "inherit",
                    }}
                    value={rawAmountReceived}
                    onChange={(e) => handleAmountReceivedChange(e.target.value)}
                    onBlur={handleAmountReceivedBlur}
                    onFocus={(e) => e.target.select()}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleAmountReceivedBlur();
                      }
                    }}
                  />
                )}

                <div style={unitStyle}>บาท</div>
              </div>
              <div style={rowStyle}>
                <div style={labelStyle}>เงินทอน:</div>
                <div style={valueStyle}>{changeAmount}</div>
                <div style={unitStyle}>บาท</div>
              </div>

              <div className="mt-4 row g-3 justify-content-start">
                {Object.keys(PAYMENT_METHODS)
                  .filter(
                    (method) =>
                      window.location.pathname !== "/bill" ||
                      ["cash", "transfer"].includes(method)
                  )
                  .map((method) => {
                    const isDisabled =
                      (isGroupASelected && GROUP_B.includes(method)) ||
                      (isGroupBSelected && GROUP_A.includes(method));

                    return (
                      <div className="col-6 text-center" key={method}>
                        <button
                          className="btn w-100"
                          onClick={() => togglePaymentMethod(method)}
                          disabled={isDisabled}
                          style={{
                            minHeight: "38px",
                            borderRadius: "6px",
                            transition: "0.3s",
                            backgroundColor: paymentType[method]
                              ? "#EF6C00"
                              : "white",
                            color: paymentType[method] ? "white" : "black",
                            fontWeight: paymentType[method] ? "bold" : "normal",
                            cursor: isDisabled ? "not-allowed" : "pointer",
                            opacity: isDisabled ? 0.5 : 1,
                            border: "1px solid #ccc",
                          }}
                        >
                          {PAYMENT_METHODS[method]}
                        </button>
                      </div>
                    );
                  })}
              </div>

              {/* <h6 class="fw-bold mt-4 text-center">
                ยอดจ่าย:{" "}
                <span
                  style={{ color: totalPaid >= grandTotal ? "green" : "red" }}
                >
                  {formatCurrency(totalPaid)}
                </span>{" "}
                บาท
              </h6> */}
            </div>

            {/* สำหรับโอน */}
            {paymentType.transfer && (
              <div className="mt-3 text-center">
                <input
                  type="file"
                  id="fileInput"
                  style={{ display: "none" }}
                  onChange={handleUploadSlip}
                  accept=".png, .jpg, .jpeg, .gif, .svg"
                />
                <button
                  className="btn"
                  onClick={() => document.getElementById("fileInput").click()}
                  style={{
                    borderRadius: "5px",
                    backgroundColor: "#EF6C00",
                    color: "#fff",
                    padding: "10px 20px",
                    fontSize: "14px",
                    minWidth: "150px",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                    transition: "background-color 0.3s",
                  }}
                >
                  อัพโหลดสลิป
                </button>

                {base64Image && (
                  <div className="mt-3">
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#333",
                      }}
                    >
                      รูปภาพสลิป:
                    </p>
                    <img
                      src={base64Image}
                      alt="อัพโหลดสลิป"
                      style={{
                        maxWidth: "20%",
                        border: "1px solid #ddd",
                        borderRadius: "5px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                      }}
                    />
                  </div>
                )}
              </div>
            )}

            {/* สำหรับเช็ค */}
            {paymentType.cheque && (
              <div
                class="p-3 rounded mt-4"
                style={{ backgroundColor: "#DCDCDC" }}
              >
                <h6 class="fw-bold mb-3">รายละเอียดเช็ค</h6>
                <div class="row g-3">
                  <div class="col-12">
                    <label class="form-label fw-bold">เลขที่เช็ค</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="กรอกเลขที่เช็ค"
                      value={chequeNo}
                      onChange={(e) => setChequeNo(e.target.value)}
                    />
                  </div>
                  <div class="col-12">
                    <label class="form-label fw-bold">ชื่อเช็ค</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="กรอกชื่อเช็ค"
                      value={chequeName}
                      onChange={(e) => setChequeName(e.target.value)}
                    />
                  </div>
                  <div class="col-12">
                    <label class="form-label fw-bold">สาขาเช็ค</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="กรอกสาขาเช็ค"
                      value={chequeBranch}
                      onChange={(e) => setChequeBranch(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          <div
            className="modal-footer"
            style={{ borderTop: "none", justifyContent: "space-between" }}
          >
            {/* <button
              type="button"
              className="btn btn-outline-secondary me-2"
              onClick={handlePayTypeClose}
              style={{ borderRadius: "5px" }}
            >
              ยกเลิก
            </button> */}
            <button
              type="button"
              className="btn"
              onClick={handleConfirmAndPrint}
              style={{
                width: "150px",
                backgroundColor: "#EF6C00",
                color: "#fff",
              }}
            >
              บันทึกและพิมพ์
            </button>
            <button
              type="button"
              className="btn"
              onClick={handleConfirmPayment}
              style={{
                borderRadius: "5px",
                backgroundColor: "#EF6C00",
                color: "#fff",
              }}
            >
              บันทึก
            </button>
          </div>
        </div>
      </div>
      {showTwoScreenModal && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "730px",
            height: 540,
            borderRadius: 14,
            // background: "#fff",
            padding: 20,
            zIndex: 2000,
            background: "rgba(26, 32, 48, 1)",
          }}
        >
          <Page2screenModal closeQR={closeQR} sessionData={currentSessionData} />
        </div>
      )}
    </div>
  );
};

export default PaymentModal;
